module.exports = __webpack_public_path__ + "components/country-flag/static/vc-0336a7c5b38d8d5057caccceed38cbd8.svg";